import api from "./api";

const baseURL = process.env.REACT_APP_CORE_REGISTRY;

export async function list(text) {
    return await api.get(`${baseURL}/api/v1/cargos?text=${text}`);
}

export async function filter(ativo, bloqueado, excluido) {
    return await api.get(`${baseURL}/api/v1/cargos-filtrar?ativo=${ativo}&excluido=${excluido}&bloqueado=${bloqueado}`);
}

export async function create(data) {
    return await api.post(`${baseURL}/api/v1/cargos`, data);
}

export async function update(data) {
    return await api.put(`${baseURL}/api/v1/cargos`, data);
}

export async function get(id) {
    return await api.get(`${baseURL}/api/v1/cargos/${id}`);
}

export async function remove(id) {
    return await api.delete(`${baseURL}/api/v1/cargos/${id}`);
}
